import { atom } from 'jotai';

/**
 * 確認モーダル
 */
export type ModalConfirmStateType = {
  open: boolean;
  title: string | null;
  message: string;
  onSubmit: () => void;
};

export const ModalConfirmState = atom<ModalConfirmStateType>({
  open: false,
  title: null,
  message: '',
  onSubmit: () => {
    return;
  },
});
